import { browserHistory } from 'react-router'
import React, { Component } from 'react'
import EmailTemplatesEditForm from "./editForm.component.jsx"
import SideBar from '../../common/layout/sidebar.component.jsx'

class EmailTemplateNew extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            documentType: this.props.match.params.documentType,
        }
    }

    componentDidMount() {
        SideBar.activateMenu('sales-tools')
    }

    render() {
        return (
            <div>
                <EmailTemplatesEditForm templateKey={this.props.match.params.templateKey} isNew={true} />
            </div>
        );
    }
}

export default EmailTemplateNew


// WEBPACK FOOTER //
// ./src/settings/emails/new.component.jsx